import TelemetryPage from './components/TelemetryPage';

const routes = [
  {
    path: '/telemetry',
    name: 'menu.telemetry',
    icon: 'activity',
    // customIcon: true,
    loginRequired: true,
    component: TelemetryPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
